export default {
  title: "Passionate Riichi, Ultra-Intense Showdown",
  game_title:
    "Mahjong Dream is a full 3D, high-energy Riichi Mahjong platform. Begin your journey into Riichi Mahjong today.",
  game_title1:
    "As the captain, you will lead a team of superpowered mahjong players in a battle for the strongest team in an otherworldly tournament.",
  header: {
    Menu: ["Home", "Characters", "Follow Us"],
  },
  role_title: "Characters",
  rolt: [
    {
      name: "Margaux",
      desc: "Innocent and Kuudere Maid High-Level Dance Challenger",
    },
    { name: "Yuna Luna", desc: "Energetic Mahjong Girl Takoyaki Master Eater" },
    { name: "Lokira", desc: "Super Popular Magician Careful Not to Become Her Prop" },
    { name: "Ranya", desc: "Mysterious Mahjong Parlor Owner Special Skill: Rebound Lute" },
    { name: "Hermor", desc: "Former eSports Player Gives His All to What He Loves" },
    { name: "Kirishima Tsuki", desc: "? ? ? ? ? ? ? ?" },
  ],
  "people": {
    "names": ["Margaux", "Yuna Luna", "Lokira", "Ranya", "Hermor", "Kirishima Tsuki","Huajiao","Celia","Evi","Leying","????","????"],
    "descs": [
      "Innocent and Kuudere Maid\n<br/>High-Level Dance Challenger",
      "Energetic Mahjong Girl\n<br/>Takoyaki Master Eater",
      "Super Popular Magician\n<br/>Careful Not to Become Her Prop",
      "Mysterious Mahjong Parlor Owner\n<br/>Special Skill:Rebound Lute",
      "Former eSports Player\n<br/>Gives His All to What He Loves",
      "Ancient Shrine Maiden<br/>Fated to You",
      "Head Chef of Chuanwei<br/>More haste, less speed",
      "Gorgeous Bounty Witch<br/>Five stars only, okay?",
      "Nature Spirit Elf<br/>Clean body, strong soul!",
      "Rising Kung Fu Star<br/>Cat, Yum Cha and Mahjong",
      "? ? ? ? ? ? ?<br/>? ? ?",
      "? ? ? ? ? ? ?<br/>? ? ?",
    ]
  },
  "footer_list": ['Terms of Service', 'Privacy Policy']
};
